module.exports = __webpack_public_path__ + "static/targ-nar-fang-gnoll-mtg_afr-98bcff315e5bae1c85cd1c5fb29cce15.jpg";